import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { useNavigate } from "react-router-dom";
import AssemblyDetails from "./AssemblyDetails";
import AssemblyDrawings from "./AssemblyDrawings";
import BOM from "./BOM/BOM";
import AssemblyAssets from "./AssemblyAssets";
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
      width: "100%",
      background: "transparant",
    },
    button: {
      margin: theme.spacing(3),
      fontFamily: "Calibri",
      fontWeight: "bold",
      color: "White",
      fontSize: "15px",
      width: "95%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    text: {
      marginTop: theme.spacing(7),
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      fontSize: "30px",
      fontFamily: "Calibri",
      fontWeight: "bold",
      marginLeft: 35,
    },
    Line: {
      border: "1px solid #3F51B5",
      width: "15%",
      marginLeft: 35,
    },
  })
);

function getSteps() {
  return ["Assembly Details", "Drawings", "BOM", "Assets"];
}
function getStepsdrawing() {
  return ["Assembly Details",  "BOM", "Assets"];
}
function getStepsdrawingassets() {
  return ["Assembly Details",  "BOM"];
}
function getStepsbomdrawing() {
  return ["Assembly Details", "Assets"];
}
function getStepsassets() {
  return ["Assembly Details", "Drawings", "BOM"];
}
function getStepsbom() {
  return ["Assembly Details", "Drawings", "Assets"];
}
function getStepsbomassets() {
  return ["Assembly Details", "Drawings"];
}
function getStepsonly() {
  return ["Assembly Details"];
}
export default function RegisterAssembly() {
  const Navigate = useNavigate();
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const Permissions = useSelector((state) => state.user.userPermissions);
  const adddrawing = Permissions.find((o) => o.codename === "add_drawing");
  const addassets = Permissions.find((o) => o.codename === "add_asset");
  const addbom = Permissions.find((o) => o.codename === "add_bom");

  const steps = getSteps();
  const stepsdrawing = getStepsdrawing();
  const stepsassets = getStepsassets();
  const stepsbom = getStepsbom();
  const stepsonly = getStepsonly();
  const stepsbomassets = getStepsbomassets();
  const stepsbomdrawing = getStepsbomdrawing();
  const stepsdrawingassets = getStepsdrawingassets();


  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <AssemblyDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 1:
        return (
          <AssemblyDrawings
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 2:
        return (
          <BOM
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 3:
        return (
          <AssemblyAssets
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );

      default:
        Navigate("/dashboard/management/items")
    }
  };

  const getStepContentdrawing = (step: number) => {
    switch (step) {
      case 0:
        return (
          <AssemblyDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
     
      case 1:
        return (
          <BOM
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 2:
        return (
          <AssemblyAssets
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );

      default:
        Navigate("/dashboard/management/items")
    }
  };
  const getStepContentdrawingassets = (step: number) => {
    switch (step) {
      case 0:
        return (
          <AssemblyDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
     
      case 1:
        return (
          <BOM
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
    

      default:
        Navigate("/dashboard/management/items")
    }
  };
  const getStepContentassets = (step: number) => {
    switch (step) {
      case 0:
        return (
          <AssemblyDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 1:
        return (
          <AssemblyDrawings
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 2:
        return (
          <BOM
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );

      default:
        Navigate("/dashboard/management/items")
    }
  };
  const getStepContentbomassets = (step: number) => {
    switch (step) {
      case 0:
        return (
          <AssemblyDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 1:
        return (
          <AssemblyDrawings
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
     

      default:
        Navigate("/dashboard/management/items")
    }
  };
  const getStepContentbom = (step: number) => {
    switch (step) {
      case 0:
        return (
          <AssemblyDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 1:
        return (
          <AssemblyDrawings
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );

      case 2:
        return (
          <AssemblyAssets
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );

      default:
        Navigate("/dashboard/management/items")
    }
  };
  const getStepContentbomdrawing = (step: number) => {
    switch (step) {
      case 0:
        return (
          <AssemblyDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
    
      case 1:
        return (
          <AssemblyAssets
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );

      default:
        Navigate("/dashboard/management/items")
    }
  };
  const getStepContentonly = (step: number) => {
    switch (step) {
      case 0:
        return (
          <AssemblyDetails
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );

      default:
        Navigate("/dashboard/management/items")
    }
  };

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  return (
    <>
      <div className="min-h-full flex items-center container my-5 ml-7">
        <div className=" w-full ">
          <div>
            <h2 className="text-left font-Montserrat text-xl font-bold text-black">
              Register New Assembly
            </h2>
            <div className="border-b-2 border-blue-200 w-24"></div>
          </div>
        </div>
      </div>

      <div className="max-w-full px-4 sm:px-6 lg:px-8">
        <div className={classes.root}>

        {!addassets ===undefined ||  addassets?.codename ===
        "add_asset" ? (
          !adddrawing ===undefined ||  adddrawing?.codename ===
        "add_drawing" ? (
          !addbom ===undefined ||  addbom?.codename ===
        "add_bom" ? (
          <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: { optional?: React.ReactNode } = {};
            if (isStepOptional(index)) {
              // labelProps.optional = (
              //   <Typography variant="caption">Optional</Typography>
              // );
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        ): 
        <Stepper activeStep={activeStep}>
        {stepsbom.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: { optional?: React.ReactNode } = {};
          if (isStepOptional(index)) {
            // labelProps.optional = (
            //   <Typography variant="caption">Optional</Typography>
            // );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
        ):  !addbom ===undefined ||  addbom?.codename ===
        "add_bom" ? (
          
          <Stepper activeStep={activeStep}>
          {stepsdrawing.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: { optional?: React.ReactNode } = {};
            if (isStepOptional(index)) {
              // labelProps.optional = (
              //   <Typography variant="caption">Optional</Typography>
              // );
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        ):(
          <Stepper activeStep={activeStep}>
          {stepsbomdrawing.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: { optional?: React.ReactNode } = {};
            if (isStepOptional(index)) {
              // labelProps.optional = (
              //   <Typography variant="caption">Optional</Typography>
              // );
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
          )


        ): !adddrawing ===undefined ||  adddrawing?.codename ===
          "add_drawing" ? (
            !addbom ===undefined ||  addbom?.codename ===
        "add_bom" ? (
          <Stepper activeStep={activeStep}>
          {stepsassets.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: { optional?: React.ReactNode } = {};
            if (isStepOptional(index)) {
              // labelProps.optional = (
              //   <Typography variant="caption">Optional</Typography>
              // );
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        ) : 
        <Stepper activeStep={activeStep}>
        {stepsbomassets.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: { optional?: React.ReactNode } = {};
          if (isStepOptional(index)) {
            // labelProps.optional = (
            //   <Typography variant="caption">Optional</Typography>
            // );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
          ): !addbom ===undefined ||  addbom?.codename ===
          "add_bom" ?( 
            <Stepper activeStep={activeStep}>
            {stepsdrawingassets.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: { optional?: React.ReactNode } = {};
              if (isStepOptional(index)) {
                // labelProps.optional = (
                //   <Typography variant="caption">Optional</Typography>
                // );
              }
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
           ) :
           <Stepper activeStep={activeStep}>
           {stepsonly.map((label, index) => {
             const stepProps: { completed?: boolean } = {};
             const labelProps: { optional?: React.ReactNode } = {};
             if (isStepOptional(index)) {
               // labelProps.optional = (
               //   <Typography variant="caption">Optional</Typography>
               // );
             }
             if (isStepSkipped(index)) {
               stepProps.completed = false;
             }
             return (
               <Step key={label} {...stepProps}>
                 <StepLabel {...labelProps}>{label}</StepLabel>
               </Step>
             );
           })}
         </Stepper>
         }
        
          <Typography className={classes.instructions}>
          {!addassets ===undefined ||  addassets?.codename ===
        "add_asset" ? (
          !adddrawing ===undefined ||  adddrawing?.codename ===
        "add_drawing" ? (
          !addbom ===undefined ||  addbom?.codename ===
        "add_bom" ? (
          getStepContent(activeStep)
        ): 
        getStepContentbom(activeStep)
        ):  !addbom ===undefined ||  addbom?.codename ===
        "add_bom" ? (
          getStepContentdrawing(activeStep)
        ):(getStepContentbomdrawing(activeStep))


        ): !adddrawing ===undefined ||  adddrawing?.codename ===
          "add_drawing" ? (
            !addbom ===undefined ||  addbom?.codename ===
        "add_bom" ? (
          getStepContentassets(activeStep)
        ) :
            getStepContentbomassets(activeStep)
          ): !addbom ===undefined ||  addbom?.codename ===
          "add_bom" ?(
          getStepContentdrawingassets(activeStep)
           ) :
           (getStepContentonly(activeStep))}

            {/* {getStepContent(activeStep)} */}
          </Typography>
        </div>
      </div>
    </>
  );
}
